module.exports = __webpack_public_path__ + "img/lamp.8588b8c9.svg";